import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

interface LegalLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

const legalLinks = [
  { path: '/legal/mentions-legales', label: 'Mentions légales' },
  { path: '/legal/cgu', label: 'CGU' },
  { path: '/legal/cgv', label: 'CGV' },
  { path: '/legal/cookies', label: 'Cookies' },
];

const LegalLayout = ({ title, subtitle, children }: LegalLayoutProps) => {
  return (
    <div className="min-h-screen bg-[#080C1E] text-white">
      {/* Header */}
      <header className="border-b border-white/[0.07] bg-[#080C1E] sticky top-0 z-50">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://storage.readdy-site.link/project_files/88b042fa-1b1e-4828-a084-65a05e6769ac/242fee5f-76d2-4bf5-b968-77fd062724cd_IMG_20260126_015045_031.webp?v=f427f7850abf122c2fe0f72017d39364"
              alt="AD.NOVA.PRO"
              className="h-8 w-auto object-contain"
            />
          </Link>
          <Link to="/" className="text-sm text-white/40 hover:text-white/80 transition-colors flex items-center gap-2 cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line"></i>
            Retour
          </Link>
        </div>
      </header>

      {/* Nav légale */}
      <div className="border-b border-white/[0.07] bg-[#0D1228]">
        <div className="max-w-5xl mx-auto px-6">
          <div className="flex gap-6 overflow-x-auto">
            {legalLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="py-3 text-sm text-white/50 hover:text-white/80 transition-colors border-b-2 border-transparent hover:border-[#C9A227] whitespace-nowrap cursor-pointer"
                style={{
                  borderBottomColor: window.location.pathname === link.path ? '#C9A227' : undefined,
                  color: window.location.pathname === link.path ? 'rgba(255,255,255,0.9)' : undefined,
                }}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Hero */}
      <div className="bg-[#0D1228] border-b border-white/[0.07]">
        <div className="max-w-5xl mx-auto px-6 py-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#C9A227]/10 border border-[#C9A227]/20 rounded-full mb-4">
            <i className="ri-shield-check-line text-[#C9A227] text-xs"></i>
            <span className="text-[#C9A227] text-xs font-medium tracking-wide uppercase">Informations légales</span>
          </div>
          <h1 className="text-3xl font-black text-white">{title}</h1>
          {subtitle && <p className="mt-2 text-white/40 text-sm">{subtitle}</p>}
        </div>
      </div>

      {/* Contenu */}
      <main className="max-w-5xl mx-auto px-6 py-12 pb-24">
        {children}
      </main>

      {/* Footer légal */}
      <footer className="border-t border-white/[0.07] bg-[#0D1228]">
        <div className="max-w-5xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src="https://storage.readdy-site.link/project_files/88b042fa-1b1e-4828-a084-65a05e6769ac/242fee5f-76d2-4bf5-b968-77fd062724cd_IMG_20260126_015045_031.webp?v=f427f7850abf122c2fe0f72017d39364"
              alt="AD.NOVA.PRO"
              className="h-6 w-auto object-contain opacity-60"
            />
            <p className="text-xs text-white/30">© 2026 AD.NOVA.PRO — MADAME AURELIE PINTO — Micro-entrepreneur</p>
          </div>
          <div className="flex gap-4 flex-wrap justify-center">
            {legalLinks.map((link) => (
              <Link key={link.path} to={link.path} className="text-xs text-white/30 hover:text-[#C9A227] transition-colors cursor-pointer">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LegalLayout;
